import { Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

/**
 * Description
 *
 * returns a helper message with clickable links guiding the user to deposit crypto/fiat
 * @param {({ origin: string })} props
 * @returns {JSX.Element}
 */

export const NoHoldings = (props: { origin?: "trade" | "target-sell" | "target-buy" }) => {
  let holdingMsg;
  let depositMsg;
  let orderMsg;
  switch (props.origin) {
    case "trade":
      holdingMsg = "Fiat or Crypto";
      depositMsg = " or crypto ";
      orderMsg = "trade";
      break;
    case "target-sell":
      holdingMsg = "crypto";
      depositMsg = " or crypto";
      orderMsg = "target sell";
      break;
    case "target-buy":
      holdingMsg = "Fiat/Stable";
      orderMsg = "target buy";
      depositMsg = " or crypto";
      break;
    default:
      holdingMsg = "Fiat/Stablecoin";
      depositMsg = " or stablecoin ";
      orderMsg = "trade";
      break;
  }
  const NO_HOLDING_TITLE = `You currently do not hold any ${holdingMsg} with us. Please deposit some to place a ${orderMsg} order.`;
  const theme = useTheme();
  const textStyle = {
    textAlign: "center",
    fontSize: "12px",
    mt: "5px",
    color: theme.palette.secondary.main,
  };
  const linkStyle = { textDecoration: "none" };
  return (
    <>
      <Typography sx={textStyle}>{NO_HOLDING_TITLE}</Typography>
      <Typography sx={textStyle}>
        {`Deposit your fiat`}
        <Link to="wallets/details" style={linkStyle}>
          {` here`}
        </Link>
        {depositMsg}
        <Link to="wallets/deposit" style={linkStyle}>{` here`}</Link>
        {` to proceed.`}
      </Typography>
    </>
  );
};
